import React, {useRef, useState} from "react"
import {v4, validate} from 'uuid'
import styles from './UuidGenerator.module.scss'


export default function UuidGenerator() {
    const outputRef = useRef()
    const upperRef = useRef()
    const [validationState, setValidationState] = useState(false);
    const [inputValue, setInputValue] = useState('');

    function generateUUID() {
        let value = v4()
        if (upperRef.current.checked) {
            value = value.toUpperCase()
        }
        return outputRef.current.value = value
    }

    function handleUpper(e) {
        if (e.currentTarget.checked) {
            return outputRef.current.value = outputRef.current.value.toUpperCase()
        }
        return outputRef.current.value = outputRef.current.value.toLowerCase()
    }

    function handleGetVersion(e) {
        setInputValue(e.currentTarget.value.trim());
        return setValidationState(validate(e.currentTarget.value.trim()))
    }

    return (
        <div className={styles.uuidGenerator}>
            <h1>UUID Generator/Validator</h1>

            <div className={styles.row}>
                <button onClick={generateUUID}>Generate v4</button>
                <input ref={outputRef} type={'text'} value={''} disabled/>
                <div><label>Uppercase</label><input onChange={handleUpper} ref={upperRef} type={'checkbox'}/></div>
            </div>

            <div className={styles.row}>
                <div>Validate UUID</div>
                <input
                    onChange={handleGetVersion}
                    className={`${validationState ? styles.valid : styles.invalid} ${!inputValue ? styles.neutral : ''}`}
                    type={'text'}
                    placeholder={'UUID string here'}
                />
                <label
                    className={`${validationState ? styles.valid : styles.invalid} ${!inputValue ? styles.hide : ''}`}>{validationState ? "Valid" : "Invalid"}</label>
            </div>

        </div>
    )
}